
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/notes/[topicGroupUID]/[topicUID]",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/notes/[topicGroupUID]/[topicUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/notes/[topicGroupUID]/[topicUID]"])
      });
    }
  